import { DOCUMENT } from '@angular/common';
import { Component, Inject, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css', '../styles.scss']
})
export class AppComponent{
  public showHeader: boolean = true;
  private iparam:any = ''; 
  public replacedUrl:boolean = false;
  constructor(private router: Router, private route: ActivatedRoute,
    private title: Title,
    private meta: Meta,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document) {
    
    this.router.events.subscribe((ev) => { 
      if (ev instanceof NavigationEnd && ev.url === '/welcome') this.showHeader = false
      if(ev instanceof NavigationEnd){
        ev.urlAfterRedirects.includes('?') ? this.iparam = ev.urlAfterRedirects.split('?')[1]?.match("i=[0-9]+") : null; 
      }
      if(ev instanceof NavigationStart){
        (this.iparam && !ev.url.includes(this.iparam)) ? location.replace(ev.url+'?'+this.iparam) : null; 
        //  ;
      }
    })
    this.title.setTitle($localize`Bhavani -  Medicina ancestral, tecnología de punta y soporte terapéutico trabajando juntos`);
    this.meta.updateTag({name: "description", content: $localize`Somos un movimiento que busca aliviar el sufrimiento humano, conectando a las personas con su corazón, con su verdadera naturaleza y con la vida mediante procesos de crecimiento y transformación que hagan a las personas libres, responsables y copartícipes de su salud.`})

    const linkCanonical = this.renderer.createElement('link');
    this.renderer.setAttribute(linkCanonical, 'rel', 'canonical');
    this.renderer.setAttribute(linkCanonical, 'href', 'https://bhavani.app/' + $localize.locale  +  this.document.URL + '/');
    this.renderer.appendChild(this.document.head, linkCanonical);

    const linkElt = this.document.createElement('link');
    const alternateLang = $localize.locale === 'es' ? 'en': 'es';
    this.renderer.setAttribute(linkElt, 'rel', 'alternate');
    this.renderer.setAttribute(linkElt, 'href', 'https://bhavani.app/' + alternateLang + this.document.URL + '/');
    this.renderer.setAttribute(linkElt, 'hreflang', alternateLang);
    this.renderer.appendChild(this.document.head, linkElt);
  }
  
  ngOnInit(): void {
  }

}
